

<ng-container *ngIf="ua">

  <div class="flex justify-content-between column-gap-1 py-3 -mx-4 px-4 border-top-1 surface-border">
  
    <div class="flex flex-column justify-content-between">
      <h5 (click)="onUserClick(ua.user)" class="m-0 mb-2 cursor-pointer hover:underline">
        {{ ua.user.orgUsers | userNameOrEmail:selectedOrg.getCurrentValue():true }}
        @if (ua.reservation.count > 1) {
          <span class="font-normal">
            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.user-reservation.additional-count' | translate: { count: ua.reservation.count - 1 } }}
          </span>
        }
        <ng-container *ngIf="ua.reservation.sessionGroupCoupleRole as role">
          <ng-container *ngIf="role === SessionGroupCoupleRole.A">
            (L)
          </ng-container>
          <ng-container *ngIf="role === SessionGroupCoupleRole.B">
            (F)
          </ng-container>
        </ng-container>
      </h5>
  
      <app-session-attendance-status-bar [sessionAttendances]="ua.sessionAttendances" [currentSessionId]="sessionAttendance?.session?.id"></app-session-attendance-status-bar>
  
      <app-reservation-status [reservation]="ua.reservation"></app-reservation-status>
      
    </div>
  
    <div class="flex flex-column align-items-center column-gap-1 flex-shrink-0">
      <p-selectButton [ngModel]="stateModel" [disabled]="FG?.disabled ?? true" class="{{btnUniqueClass}}" [options]="options" (onOptionClick)="onOptionClick($event)" optionValue="value" optionLabel="icon">
        <ng-template let-item pTemplate>
          <div class="btn w-full flex align-items-center justify-content-center ">
            <i *ngIf="item.icon" [class]="item.icon"></i>
            <span *ngIf="item.icon && item.label" class="mr-1"></span>
            <span *ngIf="item.label">
              {{ item.label }}
            </span>
          </div>
        </ng-template>
      </p-selectButton>

      <p class="m-0 text-xs">
        <ng-container *ngIf="replaced">
          <span class="text-primary">
            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.user-session-attendance-state.replaced' | translate }}
          </span>
        </ng-container>
        <ng-container *ngIf="!replaced">
          <span *ngIf="stateModel === SessionAttendanceState.ABSENT && excused" class="text-orange-300">
            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.user-session-attendance-state.excused' | translate }}
          </span>
          <span *ngIf="stateModel === SessionAttendanceState.ABSENT && !excused" class="text-red-500">
            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.user-session-attendance-state.not-excused' | translate }}
          </span>
        </ng-container>
      </p>
  
    </div>
  
  </div>

</ng-container>



